import {
  MixpanelEvents,
  MixpanelLocationTypes,
  ActionType,
  OrganisationFeatureFlags,
  accountingSystemSpecificSetting,
  ACCOUNTING_CONFIG,
} from "shared";

import { Dropdown, DropdownOption } from "../../../../common/Atoms/Dropdown";
import { mixpanelService } from "../../../../common/lib/mixpanel";
import { useAdhocActionModal } from "../../../hooks/useAdhocActionModal";
import { useGetSelectedOrganisation } from "../../../hooks/useGetSelectedOrganisation";

interface IQuickActionsProps {
  selectedContacts: number[];
  onSetParent?: () => void;
}

export function QuickActions({ selectedContacts, onSetParent }: IQuickActionsProps) {
  const { openBulkStatements, openBulkInterests, openBulkAnnouncements } = useAdhocActionModal();
  const currentOrg = useGetSelectedOrganisation();

  function onBulkStatements() {
    openBulkStatements(selectedContacts);

    mixpanelService.trackMixpanelEvent(MixpanelEvents.BulkAdhocAction, {
      location: MixpanelLocationTypes.ContactTable,
      action_type: ActionType.SEND_STATEMENT,
    });
  }

  function onBulkInterest() {
    openBulkInterests(selectedContacts);

    mixpanelService.trackMixpanelEvent(MixpanelEvents.BulkAdhocAction, {
      location: MixpanelLocationTypes.ContactTable,
      action_type: ActionType.ISSUE_STATEMENT_LATE_FEE,
    });
  }

  function onBulkAnnouncements() {
    openBulkAnnouncements(selectedContacts);

    mixpanelService.trackMixpanelEvent(MixpanelEvents.BulkAdhocAction, {
      location: MixpanelLocationTypes.ContactTable,
      action_type: ActionType.SEND_ANNOUNCEMENT,
    });
  }

  const options: Array<DropdownOption[]> = [
    [
      {
        label: `Send ${selectedContacts.length} statements`,
        onClick: onBulkStatements,
      },
      {
        label: `Charge ${selectedContacts.length} contacts interest`,
        onClick: onBulkInterest,
      },
      {
        label: `Send ${selectedContacts.length} announcements`,
        onClick: onBulkAnnouncements,
      },
    ],
  ];

  const hasManualParentChild = currentOrg?.featureFlags?.includes(OrganisationFeatureFlags.MANUAL_PARENT_CHILD);

  if (hasManualParentChild && accountingSystemSpecificSetting(currentOrg, ACCOUNTING_CONFIG.SUPPORTS_MANUAL_PARENT_CHILD)) {
    options.push([
      {
        label: `Set parent contact`,
        onClick: onSetParent,
      },
    ]);
  }

  return (
    <>
      <Dropdown
        options={ options }
        label={ `Quick Actions` }
        size={ `sm` }
        buttonColor={ `white` }
        disabled={ !selectedContacts.length }
      />
    </>
  );
}
